// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.4.1-2bW5h7N5TLEKpP3hb61d/mode=imports,min/optimized/keen-slider.js' // https://keen-slider.io/docs

const { getElement, getElements } = window.BAO.Utils

class ProductRecommendations extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.initialize()
  }

  setupListeners () {
    super.setupListeners()
  }

  async initialize () {
    if (!this.recommendationsUrl || !this.productId || !this.sectionId) {
      return
    }
    const html = await this.fetchRecommendations()
    this.render(html)
  }

  async fetchRecommendations () {
    const response = await fetch(`${this.recommendationsUrl}?${this.params}`)
    const text = await response.text()

    return this.sectionRenderer.getInnerHtml(text)
  }

  render (html) {
    if (html.length === 0 && this.parentSection) {
      this.parentSection.remove()
      return
    }

    this.removeSkeletonItems()

    if (this.childElementTarget) {
      this.childElementTarget.innerHTML =
        this.childElementTarget.innerHTML + html
      this.removeDuplicateItems()
      if (this.childElement.carousel) {
        this.childElement.carousel.update()
      }
    } else {
      this.innerHTML = this.innerHTML + html
      this.removeDuplicateItems()
    }
  }

  removeSkeletonItems () {
    getElements(`[data-skeleton-item]`, { context: this }).forEach(skeletonEl =>
      skeletonEl.remove(),
    )
  }

  removeDuplicateItems () {
    this.metafieldIds.forEach(id => {
      const duplicateElements = getElements(
        `input[name="product_id"][value="${id}"]`,
        { context: this },
      )
      if (duplicateElements.length <= 1) {
        return
      }

      duplicateElements.shift()
      duplicateElements.forEach(duplicate => {
        duplicate.closest('.prd-Recommendations_Slide').remove()
      })
    })
  }

  get parentSection () {
    return this.closest('.shopify-section')
  }

  set sectionHTML (html) {
    if (!html) return
    this.innerHTML = html
    this.isBusy = false
  }

  get sectionHTML () {
    return this.innerHTML
  }

  set isBusy (boolean) {
    this.setAttribute('aria-busy', boolean)
  }

  get isBusy () {
    return this.getAttribute('aria-busy') === 'true'
  }

  get recommendationsUrl () {
    return this.dataset?.recommendationsUrl
  }

  get productId () {
    return this.dataset?.productId
  }

  get sectionId () {
    return this.dataset?.sectionId
  }

  get metafieldIds () {
    return this.dataset?.metafieldIds.split(',')
  }

  get limit () {
    return this.dataset?.limit || 6
  }

  get sectionRenderer () {
    return window.BAO.sectionRenderer
  }

  get params () {
    // eslint-disable-next-line compat/compat
    const params = new URLSearchParams()
    params.set('product_id', this.productId)
    params.set('section_id', this.sectionId)
    params.set('limit', this.limit)
    return params.toString()
  }

  get childElement () {
    if (!this.dataset?.childElementName) return
    return getElement(this.dataset.childElementName, { context: this })
  }

  get childElementTarget () {
    if (!this.dataset?.childElementTarget) return this.childElement
    return getElement(
      `[data-${this.dataset.childElementName}-el="${this.dataset.childElementTarget}"]`,
      { context: this.childElement },
    )
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations)
}

class ProductRecommendationsCarousel extends window.BAO.CarouselElement {
  connectedCallback () {
    this.carousel = this.initialiseCarousel()
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()
    this.debouncedOnResize = window.BAO.Utils.debounce(event => {
      this.onResize(event)
    }, 250)
    this.listeners.add(window, 'resize', this.debouncedOnResize.bind(this))
  }

  onResize () {
    /* Without this the carousel breaks if initialised when hidden */
    if (!this.parentNode) return
    this.parentNode.append(this.cloneNode(true))
    this.remove()
  }

  initialiseCarousel () {
    if (!this.els?.slides?.exists || !this.els?.slide?.exists) return
    return new KeenSlider(this.els.slides.element, {
      selector: this.els.slide.selector,
      drag: true,
      loop: false,
      mode: 'snap',
      rubberband: false,
      slides: {
        origin: 'auto',
        perView: 2,
        spacing: 2,
      },
      breakpoints: {
        '(min-width: 768px)': {
          slides: {
            perView: 3,
            spacing: 15,
          },
        },
        '(min-width: 1200px)': {
          slides: {
            perView: 4,
            spacing: 15,
          },
        },
      },
    })
  }
}

if (!customElements.get('product-recommendations-carousel')) {
  customElements.define(
    'product-recommendations-carousel',
    ProductRecommendationsCarousel,
  )
}
